import styled from 'styled-components';

export const UiClassVipPassPage = styled.div`
	display: block;
`;